﻿import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MatDialog } from '@angular/material';
import * as L from 'leaflet';

import { ChartsComponent } from '../charts/charts.component';
import { DialogComponent } from '../dialog/dialog.component';
import { GeoJsonService } from '../services/geo-json.service';

import {MatSliderModule} from '@angular/material/slider';
import { ThrowStmt } from '@angular/compiler';


@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.sass']
})
export class MapComponent implements OnInit {

    // value retrieved from URL
    private selectedPeriod;
    private variable;
    private varName: string;   // variable in UPPERCASE
    public period = 30;

    private baseMaps;
    private currentLayer;        // current geojson Layer
    private borderLayer;         // border of map
    private latlng: string;      // user selecetd latlng as string, format: 34.70549, -85.58899
    private map;                 // Leaflet map obj
    private marker;              // selecetd location on map
    private preLoaderPath: string = 'http://cloud.agroclimate.org/tools/kddMonitoring/assets/images/map.gif';
    private preloaderLayer;
    private legend;
    private mapOpacity: number = 1.0;
    private mapIcon: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private service: GeoJsonService,
        public dialog: MatDialog,
        private elementRef: ElementRef
    ) { }

    ngAfterViewInit() {
        this.elementRef.nativeElement.querySelector('#opacitySlider')
            .addEventListener('input', this.setOpacity.bind(this));
    }

    setOpacity(opacityValue) {
        if (isNaN(opacityValue)) {
            opacityValue = opacityValue.target.value || opacityValue.srcElement.value;
            this.mapOpacity = opacityValue * 0.01;
            this.map.dragging.disable();
            // this.currentLayer.setStyle({opacity: (opacityValue * 0.01), fillOpacity: (opacityValue * 0.01)});
            this.currentLayer.setOpacity((opacityValue * 0.01));
            this.map.dragging.enable();
        } else {
            this.map.dragging.disable();
            // this.currentLayer.setStyle({opacity: (this.mapOpacity), fillOpacity: (this.mapOpacity)});
            this.currentLayer.setOpacity(this.mapOpacity);
            this.map.dragging.enable();
        }
    }

    // property naming in geojson is not compatiable
    // with the leaflet requirements change
    // the property naming to leaflet format
    mapColor(feature) {
        return {
            fillColor: feature.properties['fillColor'],
            fillOpacity: feature.properties['fillOpacity'],
            weight: feature.properties['strokeWidth'],
            opacity: feature.properties['strokeOpacity'],
            color: '#757575'
        };
    }

    borderStyle(feature) {
        return {
            fillOpacity: 0,
            color: '#000000',
            weight: 1
        }
    }

    generateLegend() {
        // Generate Legend
        this.service.getLegendInfo(this.variable)
            .subscribe(res => {

                if (this.legend != null) {
                    this.legend.remove();
                }
                const keys = Object.keys(res.color_map);
                this.legend = new L.Control({ position: 'topright' });

                this.legend.onAdd = function () {
                    this.div = L.DomUtil.create('div', 'mapLegend');
                    this.update();
                    return this.div;
                };

                this.legend.update = function () {
                    let html = '<div style="background-color: rgba(255,255,255,0.8); height: 280px; padding: 10px; border-radius: 5px; -webkit-print-color-adjust: exact;">';
                    html += '<i style="font-weight: bold;margin-left: 15px">ARID</i><br>';
                    html += '<div><div style="float:left; width:20px; height:10px"></div>';
                    html += '<div style="float:left; width:20px; height:10px; margin-left:5px; padding-top:3px;">1</div></div>';
                    keys.forEach(key => {
                        html += '<div>';
                        html += '<div style="float:left; background-color:' + res.color_map[key] + '; width:20px; height:20px"></div>';
                        html += '<div style="float:left; width:20px; height:20px; margin-left:5px; padding-top:14px;">';
                        if (keys.indexOf(key) < keys.length - 1) {
                            html += res.range_map[key].min;
                        } else if (keys.indexOf(key) === keys.length - 1) {
                            html += '0';
                        }
                        html += '</div></div>';
                    });
                    html += '</div>';

                    this.div.innerHTML = html;
                }

                this.legend.addTo(this.map);
            });
    }


    ngOnInit() {

        this.route.params.subscribe((params) => {

            this.selectedPeriod = params['period'];
            this.variable = params['var'];
            this.varName = this.variable.toUpperCase();

            if (this.map == null) {
                // initialize map
                this.map = L.map('map', { zoomSnap: 0.1, minZoom: 3.5 }).setView([44.8846225,-93.2203424], 4.00);
                // this.baseMaps = L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWZ1YXEiLCJhIjoiY2ptOGVpYWxmMGw5ajNrbGtlcTg0ajd3dSJ9.Hm0yOi5VEw5gePLI1mMEWw', {
                this.baseMaps = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYWdyb2NsaW1hdGUiLCJhIjoiY2tmd29ldndzMTFsZjJ0bjR1YW84Z2F6ZCJ9.ZQFnvmjyercHT0SZ-a_ssw', {
                    id: 'mapbox.streets'
                });
                this.baseMaps.addTo(this.map);

                // get border layer
                this.service.getBorderGeoJson()
                    .subscribe(res => {
                        this.borderLayer = L.geoJSON(res, { style: this.borderStyle }).addTo(this.map);
                    });

                // default marker is not working, this way is a work-around solution
                this.mapIcon = new L.Icon({
                    iconUrl: 'http://cloud.agroclimate.org/tools/kddMonitoring/assets/images/marker-icon.png',
                    iconRetinaUrl: 'http://cloud.agroclimate.org/tools/kddMonitoring/assets/images/marker-icon-2x.png',
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowUrl: 'http://cloud.agroclimate.org/tools/kddMonitoring/assets/images/marker-shadow.png',
                    shadowSize: [41, 41]
                });
            }
            if (this.currentLayer != null) {
                this.currentLayer.remove();
            }

            // config preloader
            const mapCenter = this.map.getCenter();
            const zoom = this.map.getZoom();
            const factor = Math.pow(2, zoom - 6);   // factor to keep preloader same size when zoom value changed
            this.preloaderLayer = L.imageOverlay(this.preLoaderPath, [[mapCenter.lat - 2.5 / factor, mapCenter.lng - 3 / factor], [mapCenter.lat + 2.5 / factor, mapCenter.lng + 3 / factor]]);
            // this.preloaderLayer.addTo(this.map);

            // this.service.getGeoJson(this.selectedPeriod, this.selectedBaseTemp, this.variable)
            // this.service.getGeoJson(this.selectedPeriod, this.variable)
            //     .subscribe(res => {
            //         this.preloaderLayer.remove();
            //         this.currentLayer = L.geoJSON(res, { style: this.mapColor }).addTo(this.map);
            //         this.borderLayer.bringToFront();
            //         this.setOpacity(this.mapOpacity);
            //     });

            this.currentLayer =  L.tileLayer.wms('http://ec2-18-117-93-211.us-east-2.compute.amazonaws.com/wms?geoid=us&band='+1+'&period=' + this.selectedPeriod + '&date=20220102', {
              layers: this.variable
            }).addTo(this.map);

            this.generateLegend();
            // on-click event: get latlng and add marker on map
            this.map.on('click', (e) => {
                const temp = e.latlng;
                // if (this.borderLayer.getBounds().contains(temp)) {
                    this.latlng = temp.lat + ',' + temp.lng;
                    /// *popup chart when map is clicked*/
                    const data = {
                        variable: this.variable,
                        period: this.selectedPeriod,
                        latlng: this.latlng,
                    };
                    this.dialog.closeAll();

                    this.dialog.open(DialogComponent, {
                        height: '82%',
                        width: '64%',
                        data: data
                    });

                    // check whether marker instance already exsits
                    // if not create one, if yes, update the latlng
                    if (this.marker) {
                        this.marker.setLatLng([temp.lat, temp.lng]);
                    } else {
                        this.marker = L.marker([temp.lat, temp.lng], { icon: this.mapIcon });
                        this.marker.addTo(this.map);
                    }
                // } //else {
                //alert("Please choose a location inside southeastern area");
                //}
            });


            // add AgroClimate Logo

            const mapControlsContainer = document.getElementsByClassName("leaflet-control")[0];
            const logoContainer = document.getElementById("logoContainer");
            // mapControlsContainer.appendChild(logoContainer);

        });
    }

}



// WEBPACK FOOTER //
// ./src/app/map/map.component.ts